export default function Footer({className, voltarInicio}) {
  return (
    <footer className={className}>
      © {new Date().getFullYear()} SummerTech · Todos os direitos reservados · {voltarInicio ? <a href="/" style={{ color: "var(--yellow)", textDecoration: "none" }}>Voltar ao início</a> : <></> }
    </footer>
  );
}